import React from "react";
import { Row, Container } from "react-bootstrap";

import SystemsOverviewInfo from './SystemsOverviewInfo.js';


// MAIN PAGE
function AnalisiSistemiConnessiPage() {

  return (
    <div>
        <Container>
          <Row className="text-center mt-4 mb-4">
            <h2>Analisi connessione Sistemi Laser 2D su cloud</h2>
            <p className="mt-1">Questa sezione fornisce un'analisi sullo stato di connessione dei Sistemi Laser 2D</p>
          </Row>

          <SystemsOverviewInfo />

        </Container>

    </div>
  )
}

export default AnalisiSistemiConnessiPage;


